export const hasConfig: Record<string, boolean> = {
  protein: true,
  dsi: true,
  pemea: true,
  pna:true,
};

export const hasWatchdog: Record<string, boolean> = {
  protein: true,
  pemea: true,
  dsi: true,
  proseal: true,
  pna:true,
};

export const buID: Record<string, string> = {
  1: 'pna',
  2: 'avure',
  3: 'pemea',
  4: 'aseptic',
  5: 'proseal',
  6: 'dsi',
  7: 'stnik',
  8: 'aseptic'
}